import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { View } from "@frui.ts/views";
import PersonInput from "./common/personInput";
import AddressInput from "./common/addressInput";
import ContactInput from "./common/contactInput";
import ApplicantPersonViewModel from "../../../viewModels/notice/components/applicantPersonViewModel";

const ApplicantView: FunctionComponent<{
  vm: ApplicantPersonViewModel;
}> = observer(({ vm }) => {
  const tg = (code: string) => vm.translateGeneral(`notifier.${code}`);

  return (
    <fieldset>
      <legend className="h3">{tg("title")}</legend>
      {/* TODO: enable NIA interactive form if REQUESTED */}
      {/*<Button variant="secondary" onClick={vm.redirectToNia} size="sm">*/}
      {/* tslint:disable-next-line:no-commented-code */}
      {/*  {tg("fillUsingNia")}*/}
      {/*</Button>*/}
      <PersonInput vm={vm} showBirthdate={vm.showBirthdate} />
      <AddressInput vm={vm} />
      <ContactInput vm={vm} />
      {vm.gdprViewModel && <View vm={vm.gdprViewModel} />}
    </fieldset>
  );
});

registerView(ApplicantView, ApplicantPersonViewModel);
